import React from 'react';
import { observer } from 'mobx-react';
import Helmet from 'react-helmet';
import Error404View from './Error404View';
import { scrollToTop } from '../../../utils/scrollUtils';

@observer
export default class Error404Page extends React.Component {
    componentDidMount() {
        scrollToTop();
    }

    render() {
        const meta = {
            title: `Page Not Found - Compass`,
            description: `Search for properties, access up-to-date market reports, and more. Find your way around the Compass website.`
        };

        return (
            <div>
                <Helmet>
                    <title>{meta.title}</title>
                    <meta name="description" content={meta.description} />
                    <meta property="og:title" content={meta.title} />
                    <meta
                        property="og:description"
                        content={meta.description}
                    />
                </Helmet>
                <Error404View {...this.props} />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/common/components/errors/error404/index.jsx